import server from "../middleware/interceptor";

const TERMINAL_STATUSES = new Set(["SUCCESS", "FAILURE", "REVOKED"]);
const NON_TERMINAL_STATUSES = new Set(["PENDING", "STARTED", "RETRY"]);

const sleep = (ms: number) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

export const pollTaskStatus = async (
  path: string,
  {
    intervalMs = 2000,
    timeoutMs = 5 * 60 * 1000,
  }: {
    intervalMs?: number;
    timeoutMs?: number;
  } = {}
) => {
  const startedAt = Date.now();

  while (Date.now() - startedAt < timeoutMs) {
    const response = await server.get(path, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const payload = response.data;
    const status = payload?.status;

    if (TERMINAL_STATUSES.has(status)) {
      return payload;
    }

    if (!NON_TERMINAL_STATUSES.has(status)) {
      return payload;
    }

    await sleep(intervalMs);
  }

  throw new Error("Task polling timed out");
};
